import React, { Fragment, useRef } from 'react';
import { FormGroup, Label } from 'reactstrap';
import Col from 'reactstrap/lib/Col';
import { getInputStatus, searchFileType } from '../../../services/commonServices';
import PrintInputError from '../../InputUtils/PrintInputError';
import InputDescription from '../../InputUtils/InputDescription';
import { Types } from '../../../utils/DynamicForm.config';

const TypeFormInputFileSimple = (props) => {
	const {
		id,
		label,
		name,
		value,
		editable,
		onChange,
		isEditing = true,
		required,
		errors,
		originalData = {},
		useLabel = true,
		labelColumn = { xs: '6', md: '4' },
		inputColumn = { xs: '6', md: '8' },
		alwaysEditableFields,
		relatedData,
		onlyInput
	} = props;

	const inputRef = useRef(null);
	const fileUrl = originalData[`${name}_url`];

	const isEditable = Array.isArray(alwaysEditableFields)
		? alwaysEditableFields.some((item) => item === name) || editable
		: editable;

	const handleChange = (e) => {
		const file = e.target.files && e.target.files[0];
		onChange({ target: { name, value: file || '' } });
	};

	const renderFile = () => {
		if (!fileUrl) return null;
		const fileType = searchFileType(fileUrl);
		switch (fileType) {
			case 'img':
				return (
					<a href={fileUrl} target="_blank" rel="noopener noreferrer">
						<img
							src={fileUrl}
							alt={label}
							className="pb-3"
							style={{
								maxHeight: '350px',
								maxWidth: '400px',
								height: 'fit-content',
								width: 'fit-content'
							}}
						/>
					</a>
				);
			case 'file':
				return (
					<div className="pb-3">
						<a href={fileUrl} target="_blank" rel="noopener noreferrer">{`Descargar: ${fileUrl}`}</a>
					</div>
				);
			default:
				return null;
		}
	};

	const renderLabel = () => {
		if (!useLabel) return null;
		return (
			<Col {...labelColumn}>
				<Label for={name}>
					{required ? '*' : ''} {label}
				</Label>
			</Col>
		);
	};

	const renderInput = () => (
		<Fragment>
			{renderFile()}
			<div>
				<input
				id={id || name}
				ref={inputRef}
				type="file"
				name={name}
				disabled={!isEditable || !isEditing}
				onChange={handleChange}
				className={getInputStatus(required, value || fileUrl, errors)}
			/>
			</div>
			<PrintInputError errors={errors} />
			<InputDescription description={relatedData ? relatedData.description : ''} />
		</Fragment>
	);

	if (onlyInput) return renderInput();

	return (
		<FormGroup tag="fieldset" row>
			{renderLabel()}
			<Col {...inputColumn}>{renderInput()}</Col>
		</FormGroup>
	);
};

TypeFormInputFileSimple.propTypes = Types.inputType;

export default TypeFormInputFileSimple;
